import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28,4H8V3A1,1,0,0,0,7,2H6A4,4,0,0,0,2,5.8,1.27,1.27,0,0,0,2,6V26a4,4,0,0,0,4,4H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6A2,2,0,0,1,6,4V22a3.91,3.91,0,0,0-2,.56ZM28,28H6a2,2,0,0,1,0-4H7a1,1,0,0,0,1-1V6H28Z"/><path d="M26,10.29V23.71A2.3,2.3,0,0,1,23.71,26H17a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h2a1,1,0,0,1,0,2H18v2h5.71a.29.29,0,0,0,.29-.29V16H22a1,1,0,0,1,0-2h2V10.29a.29.29,0,0,0-.29-.29H12.29a.29.29,0,0,0-.29.29V14h4V13a1,1,0,0,1,2,0v4a1,1,0,0,1-2,0V16H12v7.71a.29.29,0,0,0,.29.29H13a1,1,0,0,1,0,2h-.71A2.3,2.3,0,0,1,10,23.71V10.29A2.3,2.3,0,0,1,12.29,8H23.71A2.3,2.3,0,0,1,26,10.29Z"/>';
export var BlueprintOutlineSVG = function BlueprintOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BlueprintOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BlueprintOutlineSVG);